// extracted by mini-css-extract-plugin
export default {"card":"card_card__aqdlP","imgContainer":"card_imgContainer__q8f+6","card_text":"card_card_text__uNEqo"};